import React, { useState } from "react";
import { Layout, Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import {
  DashboardOutlined,
  FolderOutlined,
  UserOutlined,
  TeamOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import {
  SidebarContainer,
  Logo,
  LogoImage,
  MenuContainer,
} from "./Sidebar.styles";

const { Sider } = Layout;

const Sidebar: React.FC = () => {
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state: RootState) => state.auth);

  const menuItems = [
    {
      key: "/dashboard",
      icon: <DashboardOutlined />,
      label: "Tableau de bord",
    },
    {
      key: "/dossiers",
      icon: <FolderOutlined />,
      label: "Dossiers",
    },
    ...(user?.is_gestionnaire
      ? [
          {
            key: "/users",
            icon: <TeamOutlined />,
            label: "Utilisateurs",
          },
          {
            key: "references",
            icon: <DatabaseOutlined />,
            label: "Données de référence",
            children: [
              {
                key: "/references/departements",
                label: "Départements",
              },
              {
                key: "/references/groupe-clients",
                label: "Groupes clients",
              },
              {
                key: "/references/typologies",
                label: "Typologies",
              },
            ],
          },
        ]
      : []),
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key);
  };

  return (
    <SidebarContainer
      collapsible
      collapsed={collapsed}
      onCollapse={setCollapsed}
      width={280}
      theme="light"
      collapsedWidth={80}
    >
      <Logo onClick={() => navigate("/dashboard")}>
        <LogoImage src="/logo-tinsa.jpg" alt="Tinsa by Accumin" collapsed={collapsed} />
      </Logo>

      <MenuContainer>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={handleMenuClick}
          style={{ border: "none" }}
          inlineCollapsed={collapsed}
        />
      </MenuContainer>
    </SidebarContainer>
  );
};

export default Sidebar;
